const removeKey = (key, { [key]: _, ...rest }) => rest;
const removeKeys = (keys, object) =>
  (Array.isArray(keys) ? keys : []).reduce(
    (acc, key) => {
      delete acc[key];
      return { ...acc };
    },
    { ...object }
  );

const compareObjects = (a, b) => {
  let s = (o) =>
    Object.entries(o)
      .sort()
      .map((i) => {
        if (i[1] instanceof Object) i[1] = s(i[1]);
        return i;
      });
  return JSON.stringify(s(a)) === JSON.stringify(s(b));
};

export { removeKey, removeKeys, compareObjects };

export default undefined;
